var map = {
	"./archive/archive.module": "./src/app/archive/archive.module.ts",
	"./board/board.module": "./src/app/board/board.module.ts",
	"./branch/branch.module": "./src/app/branch/branch.module.ts",
	"./company/company.module": "./src/app/company/company.module.ts",
	"./display/display.module": "./src/app/display/display.module.ts",
	"./hex/hex.module": "./src/app/hex/hex.module.ts",
	"./image/image.module": "./src/app/image/image.module.ts",
	"./message/message.module": "./src/app/message/message.module.ts",
	"./sign/sign.module": "./src/app/sign/sign.module.ts",
	"./user/user.module": "./src/app/user/user.module.ts"
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;